"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppContext = exports.useAppStateInitializer = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const hooks_1 = require("../../../hooks");
const navigateTo = (dispatch) => (payload) => {
    dispatch({
        type: 'navigate',
        payload,
    });
};
const setCampaignsData = (dispatch) => (campaigns) => {
    dispatch({
        type: 'setCampaignsData',
        payload: campaigns,
    });
};
const setTemplateData = (dispatch) => (templates) => {
    dispatch({
        type: 'setTemplateData',
        payload: templates,
    });
};
function navigationReducer(state, action) {
    var _a;
    switch (action.type) {
        case 'setCampaignsData':
            return Object.assign(Object.assign({}, state), { project: Object.assign(Object.assign({}, state.project), { campaigns: action.payload }) });
        case 'setTemplateData':
            return Object.assign(Object.assign({}, state), { project: Object.assign(Object.assign({}, state.project), { templates: Object.assign(Object.assign({}, (_a = state.project) === null || _a === void 0 ? void 0 : _a.templates), action.payload) }) });
        case 'navigate':
            return Object.assign(Object.assign({}, state), { fragment: action.payload.fragment, id: action.payload.id || action.payload.fragment });
        default:
            return state;
    }
}
const initialState = {
    id: 'collections',
    fragment: 'collections',
    project: {
        campaigns: [],
        templates: {},
    },
};
const initHandler = ({ id = initialState.id, fragment = 'collections', project = initialState.project, }) => ({
    id,
    fragment,
    project,
});
function useAppStateInitializer({ thumbnails, onTemplateClick, }) {
    var _a, _b, _c;
    const [state, dispatch] = (0, react_1.useReducer)(navigationReducer, initialState, initHandler);
    const _d = (0, hooks_1.useProjectService)(), { facade } = _d, projectService = tslib_1.__rest(_d, ["facade"]);
    const project = (_a = projectService.project) !== null && _a !== void 0 ? _a : { campaigns: [], templates: {} };
    const actions = {
        navigateTo: navigateTo(dispatch),
        setCampaignsData: setCampaignsData(dispatch),
        setTemplateData: setTemplateData(dispatch),
        loadTemplates: (id) => {
            const hasCampaign = Object.keys(project.templates).find((key) => key === id);
            if (!hasCampaign) {
                facade.fetchTemplates(id);
            }
        },
        thumbnails,
        onTemplateClick,
    };
    (0, react_1.useEffect)(() => {
        project.campaigns && actions.setCampaignsData(project.campaigns);
        project.templates && actions.setTemplateData(project.templates);
    }, [(_b = project === null || project === void 0 ? void 0 : project.campaigns) === null || _b === void 0 ? void 0 : _b.length, (_c = Object.keys(project === null || project === void 0 ? void 0 : project.templates)) === null || _c === void 0 ? void 0 : _c.length]);
    return Object.assign(Object.assign({}, state), actions);
}
exports.useAppStateInitializer = useAppStateInitializer;
exports.AppContext = (0, react_1.createContext)(initialState);
//# sourceMappingURL=AppContext.js.map